/* eslint-disable */

import _ from 'lodash';
import jwtDecode from 'jwt-decode';
import { AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';
import AWSOps, { appConfig, userPool } from '../config/AWSOps';
import * as types from '../constants/ActionTypes';

export const userLogin = () => ({ type: types.USER_LOGIN });
export const userLogout = () => ({ type: types.USER_LOGOUT });
export const userLoading = (loading) => ({ type: types.USER_LOADING, loading });
export const userLoaded = (userInfo) => ({ type: types.USER_LOADED, userInfo });
export const userRegistering = (registering) => ({
  type: types.USER_REGISTERING,
  registering
});
export const userRegistered = (registered) => ({
  type: types.USER_REGISTERED,
  registered
});
export const userResetting = (resetting) => ({
  type: types.USER_RESETTING,
  resetting
});
export const userVerifying = (verifying) => ({
  type: types.USER_VERIFYING,
  verifying
});
export const userVerified = (verified) => ({
  type: types.USER_VERIFIED,
  verified
});

export const setCredentials = (token) => async () => {
  AWSOps.config.credentials = new AWSOps.CognitoIdentityCredentials({
    IdentityPoolId: appConfig.IdentityPoolId,
    Logins: { [appConfig.LoginId]: token }
  });
};

/*
called in getSession
*/
export const refreshUser = () => async () =>
  new Promise((resolve, reject) => {
    AWSOps.config.credentials.refresh((error) => {
      if (error) reject(error);
      resolve('SUCCESS');
    });
  });

/*
triggered when a user hits the Sign Out button
*/
export const logout = () => async (dispatch) => {
  const cognitoUser = userPool.getCurrentUser();
  if (cognitoUser != null) {
    cognitoUser.signOut();
  }
  dispatch(setCredentials(''));
  dispatch(userLogout());
};

/*
called in checkUser
checks if user is logged in already?
*/
export const getSession = () => async (dispatch) => {
  const cognitoUser = userPool.getCurrentUser();
  return new Promise((resolve, reject) => {
    if (cognitoUser != null) {
      cognitoUser.getSession((error, result) => {
        if (error) reject(error);
        if (result) {
          resolve(
            dispatch(setCredentials(result.getIdToken().getJwtToken()))
              .then(dispatch(refreshUser()))
              .then(resolve(result))
          );
        }
        resolve(null);
      });
    } else {
      resolve(null);
    }
  });
};

export const checkUser = () => async (dispatch) =>
  new Promise((resolve, reject) => {
    if (_.isFunction(userPool.storage.sync)) {
      userPool.storage.sync((error, result) => {
        if (error) reject(error);
        if (result) resolve(dispatch(getSession()));
      });
    } else {
      resolve(dispatch(getSession()));
    }
  });

/*
is this used for anything?
*/
export const globalLogout = () => async (dispatch) => {
  const cognitoUser = userPool.getCurrentUser();
  return new Promise((resolve, reject) => {
    if (cognitoUser != null) {
      cognitoUser.globalSignOut({
        onSuccess: (result) => {
          dispatch(setCredentials(''));
          dispatch(userLogout());
          resolve(result);
        },
        onFailure: (error) => {
          reject(error);
        }
      });
    }
  });
};

export const login = (userData) => async (dispatch) => {
  dispatch(userLoading(true));
  const { username, password, changePassword } = userData;
  const authenticationData = { Username: username, Password: password };
  const authenticationDetails = new AuthenticationDetails(authenticationData);
  const userAuthData = { Username: username, Pool: userPool };
  const cognitoUser = new CognitoUser(userAuthData);

  return new Promise((resolve, reject) => {
    const callback = {
      onSuccess: (result) => {
        const token = result.getIdToken().getJwtToken();
        const tokenData = jwtDecode(token);
        const userInfo = _.pick(tokenData, [
          'sub',
          'email',
          'phone_number',
          'given_name',
          'family_name',
          'profile'
        ]);
        userInfo.token = token;
        userInfo.groups = tokenData['cognito:groups'];
        dispatch(userLoaded(userInfo));
        dispatch(userLogin());
        resolve(dispatch(setCredentials(token)).then(resolve(cognitoUser)));
      },
      onFailure: (error) => {
        dispatch(userLoading(false));
        if (error.code === 'PasswordResetRequiredException') {
          resolve({ resetPassword: true });
        }
        reject(error);
      },
      newPasswordRequired: (userAttributes, requiredAttributes) => {
        dispatch(userLoading(false));
        delete userAttributes.email_verified;
        delete userAttributes.phone_number_verified;
        console.log(changePassword);
        const newPassword = changePassword; //new user password goes here
        cognitoUser.completeNewPasswordChallenge(
          newPassword,
          userAttributes,
          callback
        );
      }
    };
    cognitoUser.authenticateUser(authenticationDetails, callback);
  });
};

export const updatePassword = (userData) => async () => {
  const { user, password } = userData;
  const userAuthData = { Username: user.username, Pool: userPool };
  const cognitoUser = new AWSOps.CognitoIdentityServiceProvider.CognitoUser(
    userAuthData
  );
  cognitoUser.Session = user.Session;
  return new Promise((resolve, reject) => {
    const callback = {
      onSuccess: (data) => {
        console.log('success');
        console.log(data);
        resolve(data);
      },
      onFailure: (error) => {
        console.log('failure');
        console.log(error);
        reject(error);
      }
    };
    cognitoUser.completeNewPasswordChallenge(password, null, callback);
  });
};

export const forgotPassword = (userData) => async () => {
  const { username } = userData;

  const params = {
    ClientId: appConfig.ClientId,
    Username: username
  };

  const cognito = new AWSOps.CognitoIdentityServiceProvider(appConfig);
  return new Promise((resolve, reject) => {
    cognito.forgotPassword(params, (err, data) => {
      if (err) {
        console.log(err, err.stack);
        reject(err);
      } else {
        console.log(data);
        resolve('success');
      }
    });
  });
};

export const resetPassword = (userData) => async (dispatch) => {
  dispatch(userResetting(true));
  const { username, password, code } = userData;

  const cognito = new AWSOps.CognitoIdentityServiceProvider(appConfig);

  const params = {
    ClientId: appConfig.ClientId,
    ConfirmationCode: code,
    Password: password,
    Username: username
  };

  return new Promise((resolve, reject) => {
    cognito.confirmForgotPassword(params, (err, data) => {
      if (err) {
        console.log(err, err.stack);
        reject(err);
      } else {
        console.log(data);
        resolve('success');
      }
    });
  });
};
/*

is this function used anywhere

*/

export const register = (userData) => async (dispatch) => {
  dispatch(userRegistering(true));
  const { username, password, attributeList } = userData;
  return new Promise((resolve, reject) => {
    userPool.signUp(
      username,
      password,
      attributeList,
      null,
      (error, result) => {
        if (error) {
          dispatch(userRegistering(false));
          reject(error);
        }
        dispatch(userRegistered(true));
        resolve(result);
      }
    );
  });
};

/*
this is the action for confirming a registration w/ creds from ...
login?
which means login needs to be split into a "confirm login"
*/
export const verify = (userData) => async (dispatch) => {
  dispatch(userVerifying(true));
  const { username, code, password } = userData;
  const userAuthData = {
    Username: username,
    Pool: userPool,
    ConfirmationCode: code
  };
  const cognitoUser = new AWSOps.CognitoIdentityServiceProvider.CognitoUser(
    userAuthData
  );

  return new Promise((resolve, reject) => {
    //  cognitoUser.completeNewPasswordChallenge(password, attributesData, this)

    cognitoUser.confirmRegistration(code, true, (error, result) => {
      if (error) {
        dispatch(userVerifying(false));
        reject(error);
      }
      dispatch(userVerified(true));
      console.log(cognitoUser);

      resolve(result);
    });
  });
};

/*
triggers Cognito to resend the verification email ?
UI required
*/
export const resendVerification = (userData) => async () => {
  const { username } = userData;
  const cognito = new AWSOps.CognitoIdentityServiceProvider(appConfig);

  const params = {
    ClientId: appConfig.ClientId,
    Username: username
  };

  return new Promise((resolve, reject) => {
    cognito.resendConfirmationCode(params, (error, result) => {
      if (error) {
        reject(error);
      }
      resolve(result);
    });
  });
};



// WEBPACK FOOTER //
// ./src/actions/UserActions.js